import script from "./SidePanelCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelCheck.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelCheck.vue?vue&type=style&index=0&id=38b96ed0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b96ed0"]])

export default __exports__